import { EmailOutlined } from "@mui/icons-material";
import { Facebook, Instagram, Whatsapp } from "iconsax-react"

export const FOOTER_LINKS = [
  {
    title: "About us",
    path: "/about-us",
  },
  {
    title: "Rooms",
    path: "/rooms",
  },
  {
    title: "Around us",
    path: "/around-us",
  },
  {
    title: "Contact",
    path: "/contact",
  },
];

export const SOCIAL_LINKS = [
  {
    platform: "facebook",
    icon: <Facebook />,
    url: "https://www.facebook.com/villaanandagoa/",
  },
  {
    platform: "instagram",
    icon: <Instagram />,
    url: "https://www.instagram.com/inspireluxurygoa/",
  },
  {
    platform: "whatsapp",
    icon: <Whatsapp />,
    url: "https://wa.me/918308173010?text=Hi,%20I%20have%20an%20enquiry",
  },
  {
    platform: "Email",
    icon: <EmailOutlined />,
    url: "mailto:inspireluxurygoa@gmail.com",
  },
];
